import { render, staticRenderFns } from "./ExpiredScheme.vue?vue&type=template&id=2fa6ff7c&scoped=true&"
import script from "./ExpiredScheme.vue?vue&type=script&lang=js&"
export * from "./ExpiredScheme.vue?vue&type=script&lang=js&"
import style0 from "./ExpiredScheme.vue?vue&type=style&index=0&id=2fa6ff7c&prod&lang=scss&scoped=true&"
import style1 from "./ExpiredScheme.vue?vue&type=style&index=1&id=2fa6ff7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6ff7c",
  null
  
)

export default component.exports